import Item from './shared/Item';
import noop from '../../utils/noop';

var Doctype = (function (Item) {
	function Doctype () {
		Item.apply(this, arguments);
	}

	if ( Item ) Doctype.__proto__ = Item;
	Doctype.prototype = Object.create( Item && Item.prototype );
	Doctype.prototype.constructor = Doctype;

	Doctype.prototype.toString = function toString () {
		return '<!DOCTYPE' + this.template.a + '>';
	};

	return Doctype;
}(Item));

export default Doctype;

var proto = Doctype.prototype;
proto.bind = proto.render = proto.teardown = proto.unbind = proto.unrender = proto.update = noop;

//# sourceMappingURL=/home/travis/build/ractivejs/ractive/.gobble-build/01-transpile/.cache/view/items/Doctype.js.map
